/**
 * Page contains the whole login form, it's small enough not to be separated.
 */
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import t from "../service/translate.service";
import PrimaryTitle from "../components/PrimaryTitle";
import LoginRegisterSwitcher from "../components/LoginRegisterSwitcher"
import { useMsal } from "@azure/msal-react";
import { b2cPolicies } from "../azureB2C/authConfig";
import LoadingPageOverlay from "../components/LoadingPageOverlay";
import { FcGoogle } from "react-icons/fc";
import { FaApple } from "react-icons/fa";
import { useTheme } from "../providers/ThemeProvider";

const LoginPage = () => {
  const { instance } = useMsal()
  const [loading, setLoading] = useState(false)
  const language = localStorage.getItem('locale') || 'de'
  const { activeMagnifier } = useTheme()

  const handleEmailLogin = async () => {
    setLoading(true)
    const savedPath = localStorage.getItem('path')
    localStorage.removeItem('path')
    try {
      await instance.acquireTokenRedirect({
        ...b2cPolicies.authorities.emailSignIn,
        extraQueryParameters: {'ui_locales': `${language}`, magnifier: activeMagnifier.value},
        redirectStartPage: savedPath || '/'
      })
    } catch(err) {
      console.log(err)
    }
    setLoading(false)
  }

  const handleGoogleLogin = async () => {
    setLoading(true)
    const savedPath = localStorage.getItem('path')
    localStorage.removeItem('path')
    try {
      await instance.acquireTokenRedirect({
        ...b2cPolicies.authorities.googleSignUpSignIn,
        extraQueryParameters: {'ui_locales': `${language}`, magnifier: activeMagnifier.value},
        redirectStartPage: savedPath || '/'
      })
    } catch(err) {
      console.log(err)
    }
    setLoading(false)
  }

  const handleAppleLogin = async () => {
    setLoading(true)
    const savedPath = localStorage.getItem('path')
    localStorage.removeItem('path')
    try {
      await instance.acquireTokenRedirect({
        ...b2cPolicies.authorities.appleSignUpSignIn,
        extraQueryParameters: {'ui_locales': `${language}`, magnifier: activeMagnifier.value},
        redirectStartPage: savedPath || '/'
      })
    } catch(err) {
      console.log(err)
    }
    setLoading(false)
  }

  if (loading) {
    return <LoadingPageOverlay />
  }

  return (
    <div>
      <PrimaryTitle title={t.WELCOME_TITLE} />
      <LoginRegisterSwitcher />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px'
        }}
      >
        <Button
          id="loginBtn"
          onClick={() => handleEmailLogin()}
          className="button primary"
          style={{
            width: language === 'en' ? '254px' : '230px',
            justifyContent: 'center'
          }}
          aria-label={t.LOGIN_PAGE_LOGIN_WITH_EMAIL}
        >
          {t.LOGIN_PAGE_LOGIN_WITH_EMAIL}
        </Button>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            marginTop: '12px',
            marginBottom: '12px'
          }}
        >
          <div
            style={{
              width: '80px',
              height: '1px',
              backgroundColor: '#acadae'
            }}
          ></div>
          <p
            style={{
              marginBottom: '1px'
            }}
          >
            {t.LOGIN_PAGE_LOGIN_OR}
          </p>
          <div
            style={{
              width: '80px',
              height: '1px',
              backgroundColor: '#acadae'
            }}
          ></div>
        </div>
        <Button
          style={{
            width: language === 'en' ? '254px' : '230px',
            justifyContent: 'center'
          }}
          onClick={() => handleGoogleLogin()}
          className="button google"
          aria-label={t.LOGIN_PAGE_LOGIN_WITH_GOOGLE}
        >
          <FcGoogle />
          {t.LOGIN_PAGE_LOGIN_WITH_GOOGLE}
        </Button>
        <Button
          style={{
            width: language === 'en' ? '254px' : '230px',
            justifyContent: 'center'
          }}
          onClick={() => handleAppleLogin()}
          className="button apple"
          aria-label={t.LOGIN_PAGE_LOGIN_WITH_APPLE_ID}
        >
          <FaApple />
          {t.LOGIN_PAGE_LOGIN_WITH_APPLE_ID}
        </Button>
      </div>
    </div>
  );
};

export default LoginPage
